import {
	DatagridBackendFilterType,
	pushInArrayOrExactFilterIfSet,
	type BackendAdapter,
	type BackendFilter,
	type FilterValues,
} from "../types";
import type { TeamGroupRow } from "./columns";

function pushIntInArrayFilterIfSet(filters: BackendFilter[], field: string, raw: unknown): void {
	if (raw == null || !Array.isArray(raw) || raw.length === 0) {
		return;
	}

	const values = raw
		.map((value) => Number(value))
		.filter((value) => Number.isFinite(value));

	if (values.length === 0) {
		return;
	}

	filters.push({ field, type: DatagridBackendFilterType.Inarray, value: values });
}

function pushStringBooleanFiltersIfSet(filters: BackendFilter[], filterValues: FilterValues, fields: string[]): void {
	for (const field of fields) {
		const raw = filterValues[field];
		if (raw === undefined || raw === null) {
			continue;
		}

		if (raw === true || raw === "true") {
			filters.push({ field, type: DatagridBackendFilterType.Boolean, value: "true" });
			continue;
		}

		if (raw === false || raw === "false") {
			filters.push({ field, type: DatagridBackendFilterType.Boolean, value: "false" });
		}
	}
}

export const teamGroupsBackendAdapter: BackendAdapter<TeamGroupRow> = {
	buildFilters: (filterValues: FilterValues): BackendFilter[] => {
		const filters: BackendFilter[] = [];

		pushInArrayOrExactFilterIfSet(filters, "id", filterValues.id);
		pushIntInArrayFilterIfSet(filters, "teamId", filterValues.teamId);

		if (filterValues.name) {
			filters.push({
				field: "name",
				type: DatagridBackendFilterType.Search,
				value: filterValues.name,
			});
		}

		pushStringBooleanFiltersIfSet(filters, filterValues, [
			"scoutVisibility",
			"sharedAnalysis",
			"visibleTeamsheets",
		]);

		return filters;
	},
};
